import type { EntryPoint } from 'react-relay';

import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

import type DropdownFixtureComponent from '../dropdown-ui';

export const errorDropdownEntryPoint: EntryPoint<typeof DropdownFixtureComponent, {}> =
	createEntryPoint({
		root: JSResourceForInteraction<typeof DropdownFixtureComponent>(
			() =>
				new Promise<typeof DropdownFixtureComponent>((_, reject) => {
					// Deliberately fail after a short loading state; never load menu items.
					setTimeout(() => reject(new Error('Intentional dropdown documentation error')), 800);
				}),
			{ moduleId: 'constellation-error-dropdown-entry-point' },
		),
		getPreloadProps: () => ({}),
	});
